import { onpreoClient } from "@onpreo/upsy-daisy/client";
import { searchParams } from "../../utils/formatters";

const getInitialRealEstate = async documentId => {
    const url = `/api/real-estate/${documentId}${searchParams()}`;
    return await onpreoClient.get(url);
};

const fetchRealEstateById = async (realEstateId: string) => {
    const url = `/api/real-estate/${realEstateId}`;
    return await onpreoClient.get(url);
};

const realEstateService = {
    getInitialRealEstate,
    fetchRealEstateById
};

export default realEstateService;
